// extracted by mini-css-extract-plugin
module.exports = {"icon":"_02712f2b3b--icon--xr0wo","icon--opened":"_02712f2b3b--icon--opened--SaQoY","button":"_02712f2b3b--button--P2iHs"};